// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.GiStairs = function GiStairs (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 448v-64h64v-64h64v-64h64v-64h64v-64h64V64h64v384z"}}]})(props);
};
